import { render, staticRenderFns } from "./copeplan.vue?vue&type=template&id=1f02f4de&scoped=true&"
import script from "./copeplan.vue?vue&type=script&lang=js&"
export * from "./copeplan.vue?vue&type=script&lang=js&"
import style0 from "./copeplan.vue?vue&type=style&index=0&id=1f02f4de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f02f4de",
  null
  
)

export default component.exports